/* eslint-disable @next/next/no-img-element */
import React from "react";
import Modal from "react-modal";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import st from "./index.module.scss";
import VideoCover from "./VideoCover";
import HomePageHeroImg from "components/HomePageHeroImg";

type Props = {
  isVideoModalOpen: boolean;
  openVideoModal: () => void;
  closeVideoModal: () => void;
};

const YouTubeTakeover = (props: Props) => {
  return (
    <section className={st.youTubeTakeover}>
      <div className={st.youTubeTakeoverCenter} />
      <div className={st.shadow}>
        <HomePageHeroImg
          rightIcon={<VideoCover openVideoModal={props.openVideoModal} />}
        />
        <Modal
          // issue: modal content isn't loaded on page load and ignores user cookie pref
          // fixed by making content visible to the DOM but not on the page so
          // trust arc script can replace the video according to user cookie pref
          style={{
            overlay: { display: props.isVideoModalOpen ? "flex" : "none" },
          }}
          onAfterClose={clearAllBodyScrollLocks}
          // Still need to check ref because the ref returns null while modal is closing.
          overlayRef={(ref) =>
            ref && disableBodyScroll(ref, { reserveScrollBarGap: true })
          }
          isOpen={true}
          htmlOpenClassName="content-widget"
          onRequestClose={props.closeVideoModal}
          className={st.modal}
          overlayClassName={st.overlay}
          closeTimeoutMS={250}
          ariaHideApp={false}
          overlayElement={(props, content) => (
            <div {...props} className={st.overlay}>
              {content}
              <div className={st.closePlayerContainer}>
                <span className={st.closePlayerText}>CLOSE VIDEO PLAYER</span>
              </div>
            </div>
          )}
        >
          <div
            id="youtube-container"
            className="content-widget"
            style={{ height: "100%" }}
          >
            <img
              src="https://consent.trustarc.com/get?name=sampleoptedoutvideo.png"
              style={{ height: "100%", width: "100%" }}
              alt="opted out video"
            />
          </div>
        </Modal>
      </div>
    </section>
  );
};

export default YouTubeTakeover;
